import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  templates: [],
  template: null,
};

export const smsTemplatesSlice = createSlice({
  name: "smsTemplates",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setTemplates: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.templates = payload;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { setLoading, setTemplates, setError } = smsTemplatesSlice.actions;

export default smsTemplatesSlice.reducer;

export const smsTemplatesSelector = (state) => state.smsTemplates;
